"use strict";

module.exports = require("./Hasura");